export const IconFigure = () => {
  return (
    <svg
      className="w-full"
      enableBackground="new 0 0 25 25"
      viewBox="0 0 25 25"
      x="0px"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      y="0px"
    >
      <g>
        <path
          d="M12.6,1.1L12.6,1.1c6.4,0,11.5,5.1,11.5,11.5l0,0c0,6.4-5.1,11.5-11.5,11.5
		l0,0C6.3,24.1,1.1,19,1.1,12.6l0,0C1.1,6.3,6.3,1.1,12.6,1.1z"
          fill="#FEF6BD"
        />
        <path
          d="M12.6,1.8L12.6,1.8
		c6,0,10.8,4.8,10.8,10.8l0,0c0,6-4.8,10.8-10.8,10.8l0,0c-6,0-10.8-4.8-10.8-10.8l0,0C1.8,6.7,6.7,1.8,12.6,1.8z"
          fill="none"
          stroke="#FEF6BD"
          strokeWidth="1.4133"
        />
      </g>
      <path
        clipRule="evenodd"
        d="M13.3,5.6c0.2,0,0.5,0.1,0.6,0.4l1.9,3.8l4.2,0.6
	c0.2,0,0.4,0.2,0.5,0.4c0.1,0.2,0,0.5-0.2,0.7l-3,2.9l0.7,4.1c0,0.2-0.1,0.5-0.3,0.6c-0.2,0.1-0.5,0.2-0.7,0l-3.7-2l-3.7,2
	c-0.2,0.1-0.5,0.1-0.7,0c-0.2-0.1-0.3-0.4-0.3-0.6l0.7-4.1l-3-2.9c-0.2-0.2-0.2-0.4-0.2-0.7c0.1-0.2,0.3-0.4,0.5-0.4l4.2-0.6L12.7,6
	C12.8,5.7,13.1,5.6,13.3,5.6z M13.3,7.7l-1.4,2.9c-0.1,0.2-0.3,0.3-0.5,0.4l-3.2,0.5l2.3,2.2c0.2,0.1,0.2,0.4,0.2,0.6l-0.5,3.2
	l2.9-1.5c0.2-0.1,0.4-0.1,0.6,0l2.9,1.5l-0.5-3.2c0-0.2,0-0.4,0.2-0.6l2.3-2.2L15.2,11c-0.2,0-0.4-0.2-0.5-0.4L13.3,7.7z"
        fill="#BA9C06"
        fillRule="evenodd"
      />
    </svg>
  );
};
